import { createFileRoute } from '@tanstack/react-router'
import { AuditorRiskDetailsPage, auditorRiskSearchSchema } from '@/components/auditor-center/AuditorRisksPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/risks_/$riskId',
)({
  validateSearch: auditorRiskSearchSchema,
  component: AuditorRiskDetailsPage,
})
